import { render, staticRenderFns } from "./OpusInfo.vue?vue&type=template&id=e383af7e&scoped=true&"
import script from "./OpusInfo.vue?vue&type=script&lang=js&"
export * from "./OpusInfo.vue?vue&type=script&lang=js&"
import style0 from "./OpusInfo.vue?vue&type=style&index=0&id=e383af7e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e383af7e",
  null
  
)

export default component.exports